import { render, staticRenderFns } from "./orders-combiner.vue?vue&type=template&id=67474363&scoped=true"
import script from "./orders-combiner.vue?vue&type=script&lang=js"
export * from "./orders-combiner.vue?vue&type=script&lang=js"
import style0 from "./orders-combiner.vue?vue&type=style&index=0&id=67474363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67474363",
  null
  
)

export default component.exports